<template>
  <div id="the-artist">
    <b-container class="the-artist-container">
      <div class="header-cont">
        <Header title="The Artist" />
      </div>
    </b-container>

    <PlayerSpotlight
      playerName="PENNY PINCH"
      :playerImages="[
        require('@/assets/images/galleries/pennypinch/theartist/Penny-Pinch-01.jpg'),
        require('@/assets/images/galleries/pennypinch/theartist/Penny-Pinch-02.jpg'),
        require('@/assets/images/galleries/pennypinch/theartist/Penny-Pinch-03.jpg'),
        require('@/assets/images/galleries/pennypinch/theartist/Penny-Pinch-04.jpg'),
      ]"
    >
      <div slot="primaryParagraph">
        <p>
          Penny Pinch, who has been a street artist in Chicago since 2012, works
          entirely with free and found materials, never spending any money on
          supplies for his artwork.
        </p>
        <p class="italic">
          I wanted to make a statement that centered on reusing and recycling.
          The collection itself has reused and recycled materials. We only have
          one Earth. Let's be good to it.
        </p>
        <p>
          Penny Pinch is passionate about encouraging creativity in others and
          believes that art is for everyone.
          <br />
          <br />
          His work can be found on Instagram:
          <a
            href="https://www.instagram.com/_pennypinch_"
            target="_blank"
            style="color: #ce0e2d"
            >@_pennypinch_</a
          >
        </p>
      </div>
    </PlayerSpotlight>
  </div>
</template>

<script>
import ImageGallery from "@/components/global/ImageGallery";
import Header from "@/components/global/Header";
import PlayerSpotlight from "@/components/global/PlayerSpotlight";

export default {
  name: "TheArtist",
  components: {
    ImageGallery,
    Header,
    PlayerSpotlight,
  },
};
</script>

<style lang="scss" scoped>
#the-artist {
  .the-artist-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    @media (max-width: $lg) {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
  .header-cont {
    margin-top: 90px;
    margin-bottom: 40px;
  }
  .italic {
    font-family: AvenirNext-Medium-Italic;
    font-size: 16px;
    color: #3e3e3e;
    text-align: center;
    line-height: 25px;
    width: 587px;
    max-width: 100%;
    &:after {
      content: url("~@/assets/images/icons/Close-Quote-Small.svg");
      width: 16px;
      height: 10px;
      padding-left: 8px;
      transform: scale(0.5);
    }
    &:before {
      content: url("~@/assets/images/icons/Open-Quote-Small.svg");
      width: 16px;
      height: 10px;
      padding-right: 8px;
    }
  }
}
</style>
